/*
 * @Author: your name
 * @Date: 2021-07-08 17:41:56
 * @LastEditTime: 2021-07-09 10:13:30
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \JN010665\src\router\module\activity.js
 */
export default [
  {
    path: "/activity"
    // component: () => import("@views/home/index.vue")
  },
  {
    path: "/activity/poster/:id/:type",
    name: "Poster",
    meta: {
      title: "海报",
      keepAlive: false,
      backgroundColor: "#d22516",
      auth: true
    },
    component: () => import("@views/activity/Poster.vue")
  },
  {
    path: "/activity/dargain_detail/:id/:partake?",
    name: "DargainDetails",
    meta: {
      title: "砍价详情",
      keepAlive: false,
      backgroundColor: "#0e98fd ",
      auth: true
    },
    component: () => import("@views/activity/DargainDetails.vue")
  },
  {
    path: "/activity/bargain",
    name: "GoodsBargain",
    meta: {
      title: "砍价列表",
      keepAlive: false,
      backgroundColor: "rgb(233, 51, 35)"
    },
    component: () => import("@views/activity/GoodsBargain.vue")
  },
  {
    path: "/activity/bargain/record",
    name: "BargainRecord",
    meta: {
      title: "砍价记录",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/BargainRecord.vue")
  },
  {
    path: "/activity/group",
    name: "GoodsGroup",
    meta: {
      title: "拼团列表",
      keepAlive: false,
      backgroundColor: "#fa533d"
    },
    component: () => import("@views/activity/GoodsGroup.vue")
  },
  {
    path: "/activity/group_detail/:id",
    name: "GroupDetails",
    meta: {
      title: "拼团详情",
      keepAlive: false
    },
    component: () => import("@views/activity/GroupDetails.vue")
  },
  {
    path: "/activity/group_rule/:id",
    name: "GroupRule",
    meta: {
      title: "拼团",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/activity/GroupRule.vue")
  },
  {
    path: "/activity/goods_seckill",
    name: "GoodsSeckill",
    meta: {
      title: "限时抢购",
      keepAlive: false,
      backgroundColor: "#ffffff"
    },
    component: () => import("@views/activity/GoodsSeckill.vue")
  },
  {
    path: "/activity/seckill_detail/:id?/:time?/:status?",
    name: "SeckillDetails",
    meta: {
      title: "抢购详情页",
      keepAlive: true
    },
    component: () => import("@views/activity/SeckillDetails.vue")
  }
];
